// Production Firebase web config. Emulator config lives in emulatorConfig.js
// and is bundled only when REACT_APP_USE_EMULATORS=true.

export const productionFirebaseConfig = {
  apiKey: "AIzaSyB4ny0Noo6EIc8DtTVnGqrwAJOixT1IfOo",
  authDomain: "last-layer-6d53a.firebaseapp.com",
  projectId: "last-layer-6d53a",
  storageBucket: "last-layer-6d53a.firebasestorage.app",
  messagingSenderId: "664514886373",
  appId: "1:664514886373:web:79cc40889afb8616cbb20c",
  measurementId: "G-D7M6431NQD"
};
